import {PatchAttendanceTrackerAssignment} from '../backend/requests/patch-attendance-tracker-assignment';
import {AttendanceTrackerAssignment} from '../backend/responses/attendance-tracker-assignment';
import {BackendApiManager} from '../managers/backend-api';
import {PaginatedArrayResponse} from './interfaces/paginated-array-response';

export class EntityAttendanceTrackerAssignmentsRepository {
  // Singleton Instance
  private static _instance: EntityAttendanceTrackerAssignmentsRepository;

  static get instance(): EntityAttendanceTrackerAssignmentsRepository {
    if (!this._instance) {
      this._instance = new EntityAttendanceTrackerAssignmentsRepository();
    }
    return this._instance;
  }

  // Get the attendance tracker assignments that were already set in an entity
  public async getAssignments(
    entityId: string,
    limit: number,
    skip: number
  ): Promise<PaginatedArrayResponse<AttendanceTrackerAssignment>> {
    const response = await BackendApiManager.instance.get<AttendanceTrackerAssignment[]>(
      `/entities/${entityId}/attendance-tracker/assignments?limit=${limit}&skip=${skip}`
    );

    return {
      data: response.data,
      totalCount: parseInt(response.headers['x-total-count'] || '', 10),
    };
  }

  // Set if a professional must, can or does not need to track attendance
  public async updateAssignment(
    entityId: string,
    userId: string,
    body: PatchAttendanceTrackerAssignment
  ): Promise<AttendanceTrackerAssignment> {
    const response = await BackendApiManager.instance.patch<AttendanceTrackerAssignment>(
      `/entities/${entityId}/attendance-tracker/assignments/${userId}`,
      body
    );

    return response.data;
  }
}
